import styled from "styled-components";

import addresses from "assets/Layout/Dashboard/Sidebar/addresses.svg";
import hodlers from "assets/Layout/Dashboard/Sidebar/hodlers.svg";
import overview from "assets/Layout/Dashboard/Sidebar/overview.svg";
import reflections from "assets/Layout/Dashboard/Sidebar/reflections.svg";
import reinvestments from "assets/Layout/Dashboard/Sidebar/reinvestments.svg";
import rewards from "assets/Layout/Dashboard/Sidebar/rewards.svg";
import transactions from "assets/Layout/Dashboard/Sidebar/transactions.svg";
import down from "assets/Layout/Dashboard/Sidebar/down.svg";
import up from "assets/Layout/Dashboard/Sidebar/up.svg";

import vars from "variables";

const Root = styled.main`
  background: ${vars.colors.marineBlue};
  position: relative;

  li {
    font-size: 0.85rem;
    text-transform: uppercase;
  }

  ${vars.desktop.mediaQuery} {
    width: 280px;
    padding: 20px 30px;

    .toggler {
      display: none;
    }

    ul {
      margin-top: 30px;
    }

    a {
      margin-left: -32px;
      margin-bottom: 15px;
      display: block;
      border: 2px solid transparent;
    }

    a span {
      padding-left: 105px;
      display: block;
      letter-spacing: 1.5px;
      line-height: 3.75rem;
      background-repeat: no-repeat;
      background-position: 35px center;
      background-size: 47px;
    }

    a.active {
      background: linear-gradient(
            ${vars.colors.marineBlue},
            ${vars.colors.marineBlue}
          )
          padding-box,
        linear-gradient(200deg, rgb(0, 149, 213) 20%, rgb(37, 95, 157) 70%)
          border-box;
      border-radius: 0 50em 50em 0;
      border: 2px solid transparent;
    }

    a.addresses span {
      background-image: url(${addresses});
    }

    a.hodlers span {
      background-image: url(${hodlers});
    }

    a.overview span {
      background-image: url(${overview});
    }

    a.reflections span {
      background-image: url(${reflections});
    }

    a.reinvestments span {
      background-image: url(${reinvestments});
    }

    a.rewards span {
      background-image: url(${rewards});
    }

    a.transactions span {
      background-image: url(${transactions});
    }
  }

  ${vars.mobile.mediaQuery} {
    padding: 20px 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: hidden;
    z-index: 2;

    &.unfolded {
      position: relative;
      overflow: visible;
    }

    &.unfolded ul {
      display: block;
    }

    &.unfolded .toggler {
      background-image: url(${up});
    }

    .toggler {
      padding-top: 6px;
      padding-bottom: 3px;
      padding-right: 20px;
      display: block;
      font-size: 0.85rem;
      letter-spacing: 2px;
      text-transform: uppercase;
      background-image: url(${down});
      background-repeat: no-repeat;
      background-position: 100% 13px;
    }

    ul {
      top: 60px;
      left: 0;
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
      display: none;
      position: absolute;
      background: ${vars.colors.marineBlue};
      z-index: 9999;
    }

    li {
      padding: 17px;
      letter-spacing: 2px;
    }

    li a.active {
      color: ${vars.colors.blue};
    }

    body[path^="${vars.pages.claim}"] & {
      margin-top: -100px;
      padding-top: 100px;
    }
  }
`;

export { Root };
